import React, {Component} from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import {Alert, Label} from 'reactstrap';
import {Spinner} from 'react-bootstrap';
import BreadcrumbCustomer from "../../Layout/user/BreadcrumbCustomer";
import {FaCloud} from "react-icons/fa";
import { Card, CardBody } from 'reactstrap';

class AdminChangeUserProxyComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            btnSubmit: true,
            loadPage: true,
            isLoading: true,
            listService: [],
            error: false,
            messageError: '',
            email: '',
            checkEmail: false,
            listUser: {},
            userChange: "",
            errorForm: false,
            messageForm: '',
            user_id: 0,
            searchUser: '',
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getDetailListVps( this.props.listId );
    }

    getDetailListVps = (listId) => {
        this.setState({
            loadPage: true,
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/proxy/getDetailListService?listId=' + listId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listService: ref.data.content,
                        loadPage: false,
                        error: false,
                        messageError: '',
                    })
                } else {
                    if ( ref.data.error > 9000 ) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error > 8000 ) {
                        this.redirectBack(ref.data.message);
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( () => {
                this.setState({
                    loadPage: false,
                    error: true,
                    messageError: 'Lấy dữ liệu Proxy thất bại',
                })
            })
    }

    btnRedirectBack = () => {
        this.props.redirectBack();
    }

    redirectBack = (message) => {
        this.props.updateErrorNotiUser({
            error: true,
            message: message
        });
        this.props.redirectBack();
    }

    redirectSuccess = (message) => {
        this.props.updateSuccessNotiUser({
            success: true,
            message: message
        });
        this.props.redirectBack();
    }

    submit = () => {
        if ( this.state.checkEmail ) {
            this.setState({
                loadPage: true,
                btnSubmit: true,
            });
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let form = {
                listVpsIp: this.props.listId,
                userId: this.state.user_id,
            };
            // console.log(form);
            axios.put( process.env.REACT_APP_API_URL + '/api/admin/proxy/changeUserByProxy', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if ( ref.data.error === 0 ) {
                        this.setState({
                            loadPage: false,
                        })
                        this.redirectSuccess(ref.data.message);
                    } else {
                        if ( ref.data.error > 9000 ) {
                            this.props.logOut();
                        }
                        else if ( ref.data.error > 8000 ) {
                            this.redirectBack(ref.data.message);
                        }
                        else {
                            this.setState({
                                btnSubmit: false,
                                errorForm: true,
                                messageForm: ref.data.message,
                                loadPage: false,
                                checkEmail: false,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( () => {
                    this.setState({
                        loadPage: false,
                        checkEmail: false,
                        errorForm: true,
                        btnSubmit: false,
                        messageForm: 'Truy vấn dữ liệu thất bại',
                    })
                })
        } else {
            alert("Quý khách vui lòng kiểm tra khách hàng muốn chuyển.")
        }
    }

    changeInput = (event) => {
        this.setState({
            btnSubmit: true,
            [event.target.name] : event.target.type === 'checkbox' ? event.target.checked : event.target.value
        })
    }

    submitSearch = (event) => {
        if(event.key === 'Enter') {
            this.setState({
                btnSubmit: true,
            })
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            axios.get( process.env.REACT_APP_API_URL + '/api/admin/vps/searchUser?searchUser=' + this.state.searchUser,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if ( ref.data.error === 0 ) {
                        this.setState({
                            btnSubmit: true,
                            listUser: ref.data.content,
                        })
                    } else {
                        if ( ref.data.error > 9000 ) {
                            this.props.logOut();
                        }
                        else {
                            this.setState({
                                btnSubmit: true,
                                errorForm: true,
                                messageForm: ref.data.message,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( () => {
                    this.setState({
                        errorForm: true,
                        btnSubmit: true,
                        messageForm: 'Lấy dữ liệu thất bại',
                    })
                })
        }
    }

    loadSearchUser = () => {
        if ( this.state.listUser.length ) {
            return (
                <ul>
                    {
                        this.state.listUser.map( (user, key) => (
                            <li className={ (user.id === this.state.user_id ? "active" : "") + "choose-user" }
                                key={key}
                                onClick={ () => this.choosseUser( user ) }
                            >
                                { user.name }
                            </li>
                        ))
                    }
                </ul>
            );
        }
        else {
            return (
                <ul>
                    <li className="choose-user text-danger">Khách hàng không tồn tại</li>
                </ul>
            );
        }
    }

    choosseUser = (user) => {
        this.setState({
            user_id: user.id,
            userChange: user.name,
            listUser: {},
            checkEmail: true,
            btnSubmit: false,
        })
    }

    changeCheckEmail = () => {
        this.setState({
            checkEmail: false,
        })
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Chuyển khách hàng"} page={"Proxy"} icon={<FaCloud className="breadcrumb-icon"/>}/>
                            <Card className="card-change-user">
                                <CardBody>
                                    {
                                        this.state.error ? (
                                            <Alert color="danger">
                                                { this.state.messageError }
                                            </Alert>
                                        ) : (
                                            <div className="m-4">
                                                <div className="form-group row">
                                                    <div className="col-md-12 text-center">
                                                        {
                                                            this.state.errorForm ? (
                                                                <Alert color="danger">
                                                                    { this.state.messageForm }
                                                                </Alert>
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <h5>Danh sách Proxy:</h5>
                                                        <div className="col-md-3">
                                                            {
                                                                this.state.listService.map( (vps, key) => (
                                                                    <div key={key}>
                                                                        <b>{key+1}. </b> { vps.ip }
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col-md-12">
                                                        <Label for="user">Khách hàng</Label>
                                                    </div>
                                                    <div className="search-user col-md-12">
                                                        {
                                                            this.state.checkEmail ? (
                                                                <input type="text" id="user" className="form-control"
                                                                       placeholder="Tìm kiếm khách hàng"
                                                                       name="searchUser"
                                                                       value={ this.state.userChange }
                                                                       onClick={ () => this.changeCheckEmail() }
                                                                />
                                                            ) : (
                                                                <input type="text" id="user" className="form-control"
                                                                       placeholder="Tìm kiếm khách hàng"
                                                                       onChange={ this.changeInput }
                                                                       name="searchUser"
                                                                       defaultValue={ this.state.userChange }
                                                                       onKeyPress={ this.submitSearch }
                                                                />
                                                            )
                                                        }
                                                        {
                                                            this.state.listUser.length ? (
                                                                <div className="list-search-user">
                                                                    {
                                                                        this.loadSearchUser()
                                                                    }
                                                                </div>
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col-md-12 text-center">
                                                        <button className="btn btn-default mr-1"
                                                                onClick={ () => this.btnRedirectBack() }
                                                        >
                                                            Quay lại
                                                        </button>
                                                        <button className="btn btn-primary ml-1"
                                                                onClick={ () => this.submit() }
                                                                disabled={ this.state.btnSubmit }
                                                        >
                                                            Xác nhận
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                </CardBody>
                            </Card>
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerProxyChangeUser' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateErrorNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminChangeUserProxyComponent);